import React, { Component } from 'react'
import store from './store'
import { observer } from 'mobx-react'
import { Input, Button } from 'hljd'
import styles from '../style.module.less'
import { HeaderView } from '@merchant-backend/common-components'
import { PRIVILEGE_CONSULT_GIFT } from '@constant'

@observer
export default class extends Component {
  componentDidMount() {
    // 获取该商家关于到店礼的配置
    store.getGift(PRIVILEGE_CONSULT_GIFT)
  }

  render() {
    const { gift_content, gift_status, gift_reason } = store
    let header = [
      <a href={`#/localMerchant/marketingTools?key=${PRIVILEGE_CONSULT_GIFT}`}>
        咨询礼
      </a>,
      '设置咨询礼'
    ]
    return (
      <HeaderView header={header} title="设置咨询礼">
        <div className={styles.box}>
          {(gift_status == 3 || gift_status == 4) && (
            <div className={styles.pendingMsg}>
              <img src="http://qnm.hunliji.com/o_1b3c9uqm9am31qpf1rd9qr1c437.png" />
              {gift_status == 3 && (
                <span>审核中！在审核结束后，您将收到我们的通知</span>
              )}
              {gift_status == 4 && <span>{gift_reason}</span>}
            </div>
          )}

          <span className={styles.must}>咨询礼</span>
          <Input
            style={{ width: 300 }}
            value={gift_content}
            onChange={store.changeValue}
          />
          <span className={styles.num}>
            <span style={{ color: '#999' }}>
              {10 - (gift_content || '').length}
            </span>/10
          </span>

          <Button
            type="primary"
            style={{ float: 'right' }}
            onClick={store.saveGift}
          >
            保存
          </Button>

          <p style={{ color: '#999', paddingLeft: 4, marginTop: 10 }}>
            为避免用户产生歧义，请区分“到店礼”内容来设置“咨询礼”,
            例如：“咨询立送xxx元专属优惠券”;“咨询即送5张精修”
          </p>
        </div>
      </HeaderView>
    )
  }
}
